import { createStore } from 'vuex'
import setting from './modules/setting'
import userInfo from './modules/userInfo'
import upload from './modules/upload'
export default createStore({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    setting,
    userInfo,
    upload
  }
})
